<div class="d-flex flex-container">

  <p *ngIf="managementPending()" class="h3 text-center">
    Your license is being processed by the vendor, please wait...
  </p>

  <ng-container *ngIf="!managementPending()">
    <div *ngIf="initialized() && allowedOffering() as allowedOffering; else noLicense">
      <ng-container *ngIf="!auto(); else autoActivate">
        <p *ngIf="btnCaption() as caption" class="h3">{{caption}}</p>
        <button (click)="activate(allowedOffering, emplid())"
                [disabled]="loading() || managementPending()"
                [class]="btnClasses() || 'btn-primary'"
                class="btn w-100 mt-3">
          {{btnText() || 'Activate'}}
        </button>
      </ng-container>
      <ng-template #autoActivate>
        <p *ngIf="loading()" class="h3">Your license is activating, please wait...</p>
      </ng-template>
    </div>
    <ng-template #noLicense>
      <div *ngIf="initialized() && !loading()">
        <p class="h3">No license found</p>
      </div>
    </ng-template>
  </ng-container>
</div>

<div *ngIf="loading()" class="pb-4">
  <div class="py-2 d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div *ngIf="rateLimited()" class="text-center">
    <p class="">
      Our interaction with Adobe is taking a bit longer than expected, but we understand you're busy.
      <br>
      You can wait with us or you can close your browser window/tab.
      <br>
      We will send an email with instructions to your Umail account when the process is complete.
    </p>
  </div>
</div>
